import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Badge, Form, InputGroup, Dropdown, Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';
import { LanguageProvider } from '../../../core/language-provider';
import { ViewManager } from '../../../core/view-manager';
import { DataManager } from '../../../core/data-manager';
import { Utils } from '../../../core/utils';
import { toast } from 'react-toastify';
import _ from "lodash";


export default function SearchPro({ entity, setSearchObj, searchObj = null, autoFocus = false, loading = false }) {

    const properties = ViewManager.getEntityProperties(entity)
    const availableFields = Utils.cloneObject(ViewManager.getEditableColumns(entity))
    const searchableFields = Utils.cloneObject(ViewManager.getSearchableColumns(entity))
    const [activeFields, setActiveFields] = useState(searchableFields)
    const [constraints, setConstraints] = useState([])
    const [queryString, setQueryString] = useState(searchObj ? searchObj.query : '')
    const listOfUsableFilter = []
    searchableFields.map(key => {
        listOfUsableFilter.push({
            label: LanguageProvider.getLabel(entity, key),
            key: key,
            value: properties.columns[key]
        });
    });
    const usableFiltersConditions = [
        { value: 'value', label: LanguageProvider.get('search.equal') },
        { value: 'different_from_value', label: LanguageProvider.get('search.different') },
        { value: 'isnull', label: LanguageProvider.get('search.isnull') }
    ]
    const usableFiltersConditionsStrings = [
        { value: 'value', label: LanguageProvider.get('search.equal') },
        { value: 'like', label: LanguageProvider.get('search.contains') },
        { value: 'start', label: LanguageProvider.get('search.begin_by') },
        { value: 'end', label: LanguageProvider.get('search.end_by') },
        { value: 'different_from_value', label: LanguageProvider.get('search.different') },
        { value: 'in', label: LanguageProvider.get('search.in') },
        { value: 'isnull', label: LanguageProvider.get('search.isnull') }
    ]
    const usableFiltersConditionsNumbers = [
        { value: 'value', label: LanguageProvider.get('search.equal') },
        { value: 'different_from_value', label: LanguageProvider.get('search.different') },
        { value: 'minor', label: LanguageProvider.get('search.minor') },
        { value: 'greater', label: LanguageProvider.get('search.greater') },
        { value: 'in', label: LanguageProvider.get('search.in') },
        { value: 'isnull', label: LanguageProvider.get('search.isnull') }
    ]
    const usableFiltersConditionsDates = [
        { value: 'value', label: LanguageProvider.get('search.equal') },
        { value: 'different_from_value', label: LanguageProvider.get('search.different') },
        { value: 'minor', label: LanguageProvider.get('search.minor') },
        { value: 'greater', label: LanguageProvider.get('search.greater') },
        { value: 'range', label: LanguageProvider.get('search.between') },
        { value: 'isnull', label: LanguageProvider.get('search.isnull') }
    ]
    const usableFiltersConditionsOptions = [
        { value: 'in', label: LanguageProvider.get('search.in') },
        { value: 'isnull', label: LanguageProvider.get('search.isnull') }
    ]
    const usableFiltersConditionsExternalEntity = [
        { value: 'in', label: LanguageProvider.get('search.in') },
        { value: 'not_in', label: LanguageProvider.get('search.not_in') },
        { value: 'isnull', label: LanguageProvider.get('search.isnull') }
    ]


    const colourStyles = {
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            const color = "#1C3550";
            return {
                ...styles,
                backgroundColor: isSelected
                    ? color
                    : isFocused
                        ? "#1c35504d"
                        : undefined,
                color: isSelected
                    ? "white"
                    : "black",
                ':active': {
                    ...styles[':active'],
                    backgroundColor: isSelected
                        ? color
                        : "#1c35504d"
                    ,
                },
            };
        }
    };

    const [choosenField, setChoosenField] = useState("");
    const [filterType, setFilterType] = useState({});
    const [filterValue, setFilterValue] = useState("");
    const [filterValueMin, setFilterValueMin] = useState("");
    const [filterValueMax, setFilterValueMax] = useState("");
    const [isFieldSelected, setFieldSelected] = useState(false);


    function changeChoosenField(option, actionMeta) {
        if (actionMeta.action == "clear") {
            setFieldSelected(false);
        }
        else {
            setChoosenField(option.key);
            setFilterValue(''); //qua
            setFilterValueMin('');
            setFilterValueMax('');
            setFieldSelected(true);
        }
    }

    function handleFilterValueChange(event) {
        setFilterValue(event.target.value);
    }

    function changeFilterType(option, actionMeta) {
        if (actionMeta.action != "clear") {
            setFilterType(option);
            // Reset range values when changing filter type
            setFilterValueMin("");
            setFilterValueMax("");
        }
    }

    function removeConstraint(index) {
        console.log("REMOVE CONSTRAINT ")

        var newConstraints = [...constraints];
        newConstraints.splice(index, 1);
        setConstraints(newConstraints)
    }

    function handleQueryStringChange(event) {
        setQueryString(event.target.value)
    }

    function addFilter() {
        if (filterType.value === 'range') {
            // For range filters, pass min and max separately
            addConstraintRange(choosenField, filterType.value, filterValueMin, filterValueMax);
        } else if (filterType.value === 'isnull') {
            // For isnull filter, no value is needed
            addConstraint(choosenField, filterType.value, null);
        } else {
            addConstraint(choosenField, filterType.value, filterValue);
        }
        //setFieldSelected(false);
        //setFilterType("")
    }

    function addConstraint(fieldName, type, value) {
        var newConstraints = [...constraints];

        newConstraints.push({
            type: type,
            value: value,
            fieldName: fieldName
        })

        console.log("newConstraints", newConstraints)

        setConstraints(newConstraints)
        setFilterValue("");
        setFilterValueMin("");
        setFilterValueMax("");
    }

    function addConstraintRange(fieldName, type, min, max) {
        var newConstraints = [...constraints];

        newConstraints.push({
            type: type,
            min: min,
            max: max,
            fieldName: fieldName
        })

        console.log("newConstraints", newConstraints)

        setConstraints(newConstraints)
        setFilterValue("");
        setFilterValueMin("");
        setFilterValueMax("");
    }


    // begin external entity - OPTIMIZED for large datasets
    const [externalOptions, setExternalOptions] = useState([])
    const [isLoadingExternal, setIsLoadingExternal] = useState(false)

    useEffect(() => {
        if (choosenField) {
            var p = properties.columns[choosenField]
            if (p.input_type === 'externalEntity') {
                var ent = p.options.entity
                var labelField = p.options.labelField
                // Reset and load initial options
                setExternalOptions([])
                loadInitialOptions(labelField, ent)
            }
        }
    }, [choosenField]);

    async function loadInitialOptions(labelField, ent) {
        setIsLoadingExternal(true)
        try {
            const response = await DataManager.searchItemsSimple(ent, 1, 100, {
                'field': labelField,
                'order': 'asc'
            }, '', [labelField], [])
            
            if (response.success === 1) {
                const options = response.body.map(item => ({
                    value: item.id,
                    label: item[labelField] || `ID: ${item.id}`
                }))
                setExternalOptions(options)
            }
        } catch (error) {
            console.error('Error loading external options:', error)
        }
        setIsLoadingExternal(false)
    }

    async function searchExternalOptions(searchTerm, labelField, ent) {
        if (!searchTerm) {
            // If no search term, reload initial options
            return loadInitialOptions(labelField, ent)
        }

        setIsLoadingExternal(true)
        try {
            const response = await DataManager.searchItemsSimple(ent, 1, 100, {
                'field': labelField,
                'order': 'asc'
            }, searchTerm, [labelField], [])
            
            if (response.success === 1) {
                const options = response.body.map(item => ({
                    value: item.id,
                    label: item[labelField] || `ID: ${item.id}`
                }))
                setExternalOptions(options)
            }
        } catch (error) {
            console.error('Error searching external options:', error)
        }
        setIsLoadingExternal(false)
    }

    // Debounced search function
    const debouncedExternalSearch = React.useCallback(
        _.debounce((searchTerm, labelField, ent) => {
            searchExternalOptions(searchTerm, labelField, ent)
        }, 300),
        []
    )

    function handleExternalInputChange(inputValue, actionMeta) {
        if (actionMeta.action === 'input-change') {
            const p = properties.columns[choosenField]
            const ent = p.options.entity
            const labelField = p.options.labelField
            debouncedExternalSearch(inputValue, labelField, ent)
        }
    }

    function handleExternalValueChange(option, actionMeta) {
        if (actionMeta.action == "clear") {
            setFilterValue(false);
        }
        else {
            console.log(option)
            setFilterValue(option.value);
        }
    }
    // end external

    function handleOptionValueChange(option, actionMeta) {
        if (actionMeta.action == "clear") {
            setFilterValue(false);
        }
        else {
            console.log(option)
            var string = ''
            for (var j = 0; j < option.length; j++) {
                if (string.length > 0) {
                    string += ','
                }
                string += option[j].value
            }
            setFilterValue(string);
        }
    }



    function search(obj) {
        if (_.isEqual(obj, searchObj)) {
            console.log('searchObj = : non triggero la ricerca')
            // oggetti uguali non triggero la ricerca
        }
        else {
            console.log('searchObj <> : triggero la ricerca', obj, searchObj)
            setSearchObj(obj)
        }
    }

    /*
    useEffect(() => {
        let data = {
            'query': queryString,
            'fields': activeFields,
            'constraints': constraints
        }
        console.log("--- CALLING seachCallback() ---")
        console.log(data)

        const timeOutId = setTimeout(() => search(data), 400);
        return () => clearTimeout(timeOutId);

    }, [queryString, activeFields, constraints]);
    */

    useEffect(() => {
        let data = {
            'query': queryString,
            'fields': activeFields,
            'constraints': constraints
        }
        console.log("--- CALLING seachCallback() ---")
        console.log(data)

        const timeOutId = setTimeout(() => search(data), 400);
        return () => clearTimeout(timeOutId);

    }, [constraints]);


    function triggerSearch() {
        let data = {
            'query': queryString,
            'fields': activeFields,
            'constraints': constraints
        }
        console.log("--- CALLING seachCallback() ---")
        console.log(data)

        search(data)
    }

    function resetSearch() {
        setQueryString('')

        let data = {
            'query': '',
            'fields': activeFields,
            'constraints': constraints
        }
        console.log("--- CALLING seachCallback() ---")
        console.log(data)

        search(data)
    }


    useEffect(() => {
        console.log(properties, availableFields, searchableFields)

        //popolo filtri partendo da params
        if (searchObj !== null) {
            if (searchObj.query && searchObj.query.length > 0) {
                setQueryString(searchObj.query)
            }
            if (searchObj.constraints && searchObj.constraints.length > 0) {
                var temp = []
                for (var i = 0; i < searchObj.constraints.length; i++) {
                    var c = searchObj.constraints[i]
                    if (c.type === 'range') {
                        temp.push({ fieldName: c.fieldName, type: c.type, min: c.min, max: c.max, range_type: 'STR' })
                    } else {
                        temp.push({ fieldName: c.fieldName, type: c.type, value: c.value })
                    }
                }
                setConstraints(temp)
            }
            else {
                if(constraints && constraints.length > 0) {
                    setConstraints([])
                }
            }
        }
    }, [searchObj]);



    //salvataggio filtri
    const [filterGroupName, setFilterGroupName] = useState('')
    const [entityUserFilters, setEntityUserFilters] = useState([])
    async function saveFiltersGroup() {
        if (filterGroupName.length && constraints.length) {
            var body = {
                content: JSON.stringify(constraints),
                name: filterGroupName,
                entity: entity
            }
            var response = await DataManager.insertItem('user_entity_saved_filters', body)
            if (response.success === 1) {
                toast.success(LanguageProvider.get('search.success_filters_saved'), { theme: 'colored' });
                getUserFilters()
            }
            else {
                toast.error(LanguageProvider.get('search.fail_filters_saved'), { theme: 'colored' });
            }
        }
        else {
            toast.error(LanguageProvider.get('search.fail_filters_saved'), { theme: 'colored' });
        }
    }
    async function getUserFilters() {
        var c = [
            {
                fieldName: 'entity',
                type: 'value',
                value: entity
            }
        ]
        var response = await DataManager.searchItems('user_entity_saved_filters', 1, 20, { 'field': 'name', 'order': 'ASC' }, '', [], c)
        if (response.success === 1) {
            if (response.body && response.body.length) {
                setEntityUserFilters(response.body)
            }
        }
    }
    function applyFilters(item) {
        setConstraints(JSON.parse(item.content))
    }
    const [filterToDelete, setFilterToDelete] = useState(null);
    function askDeleteUserFilter(e, item) {
        e.stopPropagation();
        setFilterToDelete(item);
    }
    async function confirmDeleteUserFilter() {
        if (!filterToDelete) return;
        var response = await DataManager.deleteItem('user_entity_saved_filters', filterToDelete.id)
        if (response.success === 1) {
            toast.success(LanguageProvider.get('search.success_filters_saved'), { theme: 'colored' });
            getUserFilters()
        }
        setFilterToDelete(null);
    }
    useEffect(() => {
        getUserFilters()
    }, []);

    function resetFilters() {
        setConstraints([])
    }



    return (
        <>
            <Container fluid className='mt-1 mb-1' style={{ paddingLeft: 0, paddingRight: 0 }}>
                <InputGroup className='search-adv'>
                    <Dropdown>
                        <Dropdown.Toggle variant="primary">
                            {LanguageProvider.get('search.filters')}
                            {constraints && constraints.length > 0 ? (
                                <Badge bg="danger" className='ms-2'>{constraints.length}</Badge>
                            ) : (
                                <></>
                            )}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Header>
                                <Row>
                                    <Col xs={12} md={6}>
                                        {LanguageProvider.get('search.add_filter')}
                                        <p className='small-description-text'>{LanguageProvider.get('search.add_filter_subtitle')}</p>

                                        <span className='small'>{LanguageProvider.get('search.field_label')}</span>
                                        <Select onChange={changeChoosenField} className="basic-single" classNamePrefix="select" defaultValue={""}
                                            isClearable={false} isSearchable={true} styles={colourStyles} options={listOfUsableFilter} />

                                        <span className='small'>{LanguageProvider.get('search.type_label')}</span>
                                        {(() => {
                                            if (typeof (properties.columns[choosenField]) !== 'undefined') {
                                                switch (properties.columns[choosenField].input_type) {
                                                    case 'string': return (
                                                        <Select className="basic-single" onChange={changeFilterType} classNamePrefix="select" defaultValue={""} value={filterType}
                                                            isClearable={true} isSearchable={true} styles={colourStyles} options={usableFiltersConditionsStrings} />
                                                    );
                                                    case 'text': return (
                                                        <Select className="basic-single" onChange={changeFilterType} classNamePrefix="select" defaultValue={""} value={filterType}
                                                            isClearable={true} isSearchable={true} styles={colourStyles} options={usableFiltersConditionsStrings} />
                                                    );
                                                    case 'email': return (
                                                        <Select className="basic-single" onChange={changeFilterType} classNamePrefix="select" defaultValue={""} value={filterType}
                                                            isClearable={true} isSearchable={true} styles={colourStyles} options={usableFiltersConditionsStrings} />
                                                    );
                                                    case 'float': return (
                                                        <Select className="basic-single" onChange={changeFilterType} classNamePrefix="select" defaultValue={""} value={filterType}
                                                            isClearable={true} isSearchable={true} styles={colourStyles} options={usableFiltersConditionsNumbers} />
                                                    );
                                                    case 'number': return (
                                                        <Select className="basic-single" onChange={changeFilterType} classNamePrefix="select" defaultValue={""} value={filterType}
                                                            isClearable={true} isSearchable={true} styles={colourStyles} options={usableFiltersConditionsNumbers} />
                                                    );
                                                    case 'date': return (
                                                        <Select className="basic-single" onChange={changeFilterType} classNamePrefix="select" defaultValue={""} value={filterType}
                                                            isClearable={true} isSearchable={true} styles={colourStyles} options={usableFiltersConditionsDates} />
                                                    );
                                                    case 'time': return (
                                                        <Select className="basic-single" onChange={changeFilterType} classNamePrefix="select" defaultValue={""} value={filterType}
                                                            isClearable={true} isSearchable={true} styles={colourStyles} options={usableFiltersConditionsDates} />
                                                    );
                                                    case 'datetime': return (
                                                        <Select className="basic-single" onChange={changeFilterType} classNamePrefix="select" defaultValue={""} value={filterType}
                                                            isClearable={true} isSearchable={true} styles={colourStyles} options={usableFiltersConditionsDates} />
                                                    );
                                                    case 'boolean': return (
                                                        <Select className="basic-single" onChange={changeFilterType} classNamePrefix="select" defaultValue={""} value={filterType}
                                                            isClearable={true} isSearchable={true} styles={colourStyles} options={usableFiltersConditions} />
                                                    );
                                                    case 'externalEntity': return (
                                                        <Select className="basic-single" onChange={changeFilterType} classNamePrefix="select" defaultValue={""} value={filterType}
                                                            isClearable={true} isSearchable={true} styles={colourStyles} options={usableFiltersConditionsExternalEntity} />
                                                    );
                                                    case 'option': return (
                                                        <Select className="basic-single" onChange={changeFilterType} classNamePrefix="select" defaultValue={""} value={filterType}
                                                            isClearable={true} isSearchable={true} styles={colourStyles} options={usableFiltersConditionsOptions} />
                                                    );
                                                    default: return (
                                                        <Select className="basic-single" onChange={changeFilterType} classNamePrefix="select" defaultValue={""} value={filterType}
                                                            isClearable={true} isSearchable={true} styles={colourStyles} options={usableFiltersConditions} />
                                                    );
                                                }
                                            }
                                            else {
                                                return (
                                                    <Select className="basic-single" onChange={changeFilterType} classNamePrefix="select" defaultValue={""} value={filterType}
                                                        isClearable={true} isSearchable={true} styles={colourStyles} options={usableFiltersConditions} />
                                                )
                                            }
                                        })()}

                                        <span className='small'>{LanguageProvider.get('search.field_value')}</span>
                                        {isFieldSelected && filterType.value !== 'isnull' ?
                                            <div className="mb-3">

                                                {(() => {
                                                    if (typeof (properties.columns[choosenField]) !== 'undefined') {
                                                        switch (properties.columns[choosenField].input_type) {
                                                            case 'string': return (
                                                                <Form.Control value={filterValue} onChange={handleFilterValueChange} type="text" />
                                                            );
                                                            case 'text': return (
                                                                <Form.Control value={filterValue} onChange={handleFilterValueChange} type="text" />
                                                            );
                                                            case 'email': return (
                                                                <Form.Control value={filterValue} onChange={handleFilterValueChange} type="text" />
                                                            );
                                                            case 'float': return (
                                                                <Form.Control type="number" value={filterValue} onChange={handleFilterValueChange} />
                                                            );
                                                            case 'number': return (
                                                                <Form.Control type="number" value={filterValue} onChange={handleFilterValueChange} />
                                                            );
                                                            case 'date': return (
                                                                <>
                                                                    {filterType.value === 'range' ? (
                                                                        <InputGroup size='sm'>
                                                                            <Form.Control
                                                                                type="date"
                                                                                value={filterValueMin}
                                                                                onChange={(e) => setFilterValueMin(e.target.value)}
                                                                                placeholder={LanguageProvider.get('search.from')}
                                                                            />
                                                                            <Form.Control
                                                                                type="date"
                                                                                value={filterValueMax}
                                                                                onChange={(e) => setFilterValueMax(e.target.value)}
                                                                                placeholder={LanguageProvider.get('search.to')}
                                                                            />
                                                                        </InputGroup>
                                                                    ) : (
                                                                        <Form.Control
                                                                            type="date"
                                                                            value={filterValue}
                                                                            onChange={handleFilterValueChange}
                                                                        />
                                                                    )}
                                                                </>
                                                            );
                                                            case 'time': return (
                                                                <>
                                                                    {filterType.value === 'range' ? (
                                                                        <InputGroup size='sm'>
                                                                            <Form.Control
                                                                                type="time"
                                                                                value={filterValueMin}
                                                                                onChange={(e) => setFilterValueMin(e.target.value)}
                                                                                placeholder={LanguageProvider.get('search.from')}
                                                                            />
                                                                            <Form.Control
                                                                                type="time"
                                                                                value={filterValueMax}
                                                                                onChange={(e) => setFilterValueMax(e.target.value)}
                                                                                placeholder={LanguageProvider.get('search.to')}
                                                                            />
                                                                        </InputGroup>
                                                                    ) : (
                                                                        <Form.Control
                                                                            type="time"
                                                                            value={filterValue}
                                                                            onChange={handleFilterValueChange}
                                                                        />
                                                                    )}
                                                                </>
                                                            );
                                                            case 'datetime': return (
                                                                <>
                                                                    {filterType.value === 'range' ? (
                                                                        <InputGroup size='sm'>
                                                                            <Form.Control
                                                                                type="datetime-local"
                                                                                value={filterValueMin}
                                                                                onChange={(e) => setFilterValueMin(e.target.value)}
                                                                                placeholder={LanguageProvider.get('search.from')}
                                                                            />
                                                                            <Form.Control
                                                                                type="datetime-local"
                                                                                value={filterValueMax}
                                                                                onChange={(e) => setFilterValueMax(e.target.value)}
                                                                                placeholder={LanguageProvider.get('search.to')}
                                                                            />
                                                                        </InputGroup>
                                                                    ) : (
                                                                        <Form.Control
                                                                            type="datetime-local"
                                                                            value={filterValue}
                                                                            onChange={handleFilterValueChange}
                                                                        />
                                                                    )}
                                                                </>
                                                            );
                                                            case 'boolean': return (
                                                                <Form.Select onChange={handleFilterValueChange}>
                                                                    <option value='null'>Seleziona</option>
                                                                    <option value="1">{LanguageProvider.get('defaults.true')}</option>
                                                                    <option value="0">{LanguageProvider.get('defaults.false')}</option>
                                                                </Form.Select>
                                                            );
                                                            case 'externalEntity': 
                                                                // Always use multi-select for externalEntity (only 'in' filter)
                                                                const selectedIds = filterValue ? filterValue.split(',').map(v => v.trim()) : [];
                                                                
                                                                // Keep selected options even if not in current search results
                                                                const selectedOptions = selectedIds.map(id => {
                                                                    const found = externalOptions.find(opt => String(opt.value) === String(id));
                                                                    if (found) return found;
                                                                    // Return a basic option for selected items not in current results
                                                                    return { value: id, label: `ID: ${id}` };
                                                                }).filter(Boolean);
                                                                
                                                                // Merge selected options with search results, removing duplicates
                                                                const allOptions = [...selectedOptions];
                                                                externalOptions.forEach(opt => {
                                                                    if (!selectedIds.includes(String(opt.value))) {
                                                                        allOptions.push(opt);
                                                                    }
                                                                });
                                                                
                                                                return (
                                                                    <>
                                                                        <Select 
                                                                            className="basic-multi-select" 
                                                                            isMulti={true}
                                                                            value={selectedOptions}
                                                                            onChange={(selectedOptions) => {
                                                                                const values = selectedOptions ? selectedOptions.map(opt => opt.value).join(',') : '';
                                                                                setFilterValue(values);
                                                                            }}
                                                                            onInputChange={handleExternalInputChange}
                                                                            classNamePrefix="select" 
                                                                            isLoading={isLoadingExternal} 
                                                                            isClearable={true} 
                                                                            isSearchable={true} 
                                                                            styles={colourStyles} 
                                                                            options={allOptions}
                                                                            placeholder="Type to search..."
                                                                            noOptionsMessage={({ inputValue }) => 
                                                                                inputValue ? `No results for "${inputValue}"` : 'Start typing to search...'
                                                                            }
                                                                            loadingMessage={() => 'Searching...'}
                                                                        />
                                                                    </>
                                                                );
                                                            case 'option': {
                                                                var optionSelect = []
                                                                for (var j = 0; j < properties.columns[choosenField].options.options.length; j++) {
                                                                    var option = properties.columns[choosenField].options.options[j]
                                                                    var optionVPkey = choosenField + '.options.' + option.value
                                                                    optionSelect.push({
                                                                        value: option.value,
                                                                        label: LanguageProvider.getLabel(entity, optionVPkey)
                                                                    })
                                                                }
                                                                return (
                                                                    <Select className="basic-multi-select" isMulti onChange={handleOptionValueChange} classNamePrefix="select" defaultValue={""}
                                                                        isClearable={true} isSearchable={true} styles={colourStyles} options={optionSelect} />
                                                                )
                                                            };
                                                            default: return (
                                                                <Form.Control value={filterValue} onChange={handleFilterValueChange} type="text" />
                                                            );
                                                        }
                                                    }
                                                })()}

                                            </div>
                                            :
                                            <p className='medium-select-description-text'>{LanguageProvider.get('search.select_constraint_field')}</p>
                                        }

                                        <Button size="sm" disabled={
                                            filterType.length == 0 ||
                                            (filterType.value === 'range'
                                                ? (!filterValueMin || filterValueMin.length == 0 || !filterValueMax || filterValueMax.length == 0)
                                                : (filterType.value === 'isnull'
                                                    ? false
                                                    : (!filterValue || filterValue.length == 0)))
                                        } onClick={addFilter} variant="primary">
                                            {LanguageProvider.get('defaults.add')}
                                        </Button>
                                    </Col>

                                    <Col xs={12} md={6}>
                                        {LanguageProvider.get('search.active_filters')}
                                        <p className='small-description-text'>{LanguageProvider.get('search.active_filters_subtitle')}</p>

                                        <div>
                                            {constraints.map((item, index) => {
                                                return (
                                                    <Row key={index} className="mb-3 align-items-center w-100">
                                                        <Col xs={9} style={{ whiteSpace: 'break-spaces' }}>
                                                            <Badge>{LanguageProvider.getLabel(entity, item.fieldName)}</Badge>

                                                            {(() => {
                                                                switch (item.type.toUpperCase()) {
                                                                    case 'IN': {
                                                                        const myArray = item.value.split(",")
                                                                        return (
                                                                            <>
                                                                                <Badge className='me-2 ms-2' bg={'secondary'}>{LanguageProvider.get('search.in')}</Badge>
                                                                                <span style={{ whiteSpace: 'break-spaces' }}>
                                                                                    {myArray.map((el, index) => {
                                                                                        return (
                                                                                            <Badge bg="info" className='me-1' key={index}>{el}</Badge>
                                                                                        )
                                                                                    })}
                                                                                </span>
                                                                            </>
                                                                        )
                                                                    };
                                                                    case 'NOT_IN': {
                                                                        const myArrayNotIn = item.value.split(",")
                                                                        return (
                                                                            <>
                                                                                <Badge className='me-2 ms-2' bg={'secondary'}>{LanguageProvider.get('search.not_in')}</Badge>
                                                                                <span style={{ whiteSpace: 'break-spaces' }}>
                                                                                    {myArrayNotIn.map((el, index) => {
                                                                                        return (
                                                                                            <Badge bg="warning" className='me-1' key={index}>{el}</Badge>
                                                                                        )
                                                                                    })}
                                                                                </span>
                                                                            </>
                                                                        )
                                                                    };
                                                                    case 'LIKE': {
                                                                        return (
                                                                            <>
                                                                                <Badge className='me-2 ms-2' bg={'secondary'}>{LanguageProvider.get('search.contains')}</Badge>
                                                                                <Badge bg="info">{item.value}</Badge>
                                                                            </>
                                                                        )
                                                                    };
                                                                    case 'START': {
                                                                        return (
                                                                            <>
                                                                                <Badge className='me-2 ms-2' bg={'secondary'}>{LanguageProvider.get('search.begin_by')}</Badge>
                                                                                <Badge bg="info">{item.value}</Badge>
                                                                            </>
                                                                        )
                                                                    };
                                                                    case 'END': {
                                                                        return (
                                                                            <>
                                                                                <Badge className='me-2 ms-2' bg={'secondary'}>{LanguageProvider.get('search.end_by')}</Badge>
                                                                                <Badge bg="info">{item.value}</Badge>
                                                                            </>
                                                                        )
                                                                    };
                                                                    case 'VALUE': {
                                                                        return (
                                                                            <>
                                                                                <Badge className='me-2 ms-2' bg={'secondary'}>{LanguageProvider.get('search.equal')}</Badge>
                                                                                <Badge bg="info">{item.value}</Badge>
                                                                            </>
                                                                        )
                                                                    };
                                                                    case 'DIFFERENT_FROM_VALUE': {
                                                                        return (
                                                                            <>
                                                                                <Badge className='me-2 ms-2' bg={'secondary'}>{LanguageProvider.get('search.different')}</Badge>
                                                                                <Badge bg="info">{item.value}</Badge>
                                                                            </>
                                                                        )
                                                                    };
                                                                    case 'MINOR': {
                                                                        return (
                                                                            <>
                                                                                <Badge className='me-2 ms-2' bg={'secondary'}>{LanguageProvider.get('search.minor')}</Badge>
                                                                                <Badge bg="info">{item.value}</Badge>
                                                                            </>
                                                                        )
                                                                    };
                                                                    case 'GREATER': {
                                                                        return (
                                                                            <>
                                                                                <Badge className='me-2 ms-2' bg={'secondary'}>{LanguageProvider.get('search.greater')}</Badge>
                                                                                <Badge bg="info">{item.value}</Badge>
                                                                            </>
                                                                        )
                                                                    };
                                                                    case 'RANGE': {
                                                                        return (
                                                                            <>
                                                                                <Badge className='me-2 ms-2' bg={'secondary'}>{LanguageProvider.get('search.between')}</Badge>
                                                                                <Badge bg="info">{item.min}</Badge>
                                                                                <Badge className='mx-1' bg={'secondary'}>{LanguageProvider.get('search.and')}</Badge>
                                                                                <Badge bg="info">{item.max}</Badge>
                                                                            </>
                                                                        )
                                                                    };
                                                                    case 'ISNULL': {
                                                                        return (
                                                                            <>
                                                                                <Badge className='me-2 ms-2' bg={'secondary'}>{LanguageProvider.get('search.isnull')}</Badge>
                                                                            </>
                                                                        )
                                                                    };
                                                                    default: return (
                                                                        <>
                                                                            <Badge className='me-2 ms-2' bg={'secondary'}>{item.type}</Badge>
                                                                            <Badge bg="info">{typeof item.value === 'object' ? JSON.stringify(item.value) : item.value}</Badge>
                                                                        </>
                                                                    );
                                                                }
                                                            })()}
                                                        </Col>
                                                        <Col xs={3} className='text-end'>
                                                            <Badge pill bg="danger" role="button" onClick={() => { removeConstraint(index) }}>
                                                                <FontAwesomeIcon icon="xmark" size={'lg'} />
                                                            </Badge>
                                                        </Col>
                                                    </Row>
                                                );
                                            })}
                                        </div>

                                        {constraints && constraints.length > 0 ? (
                                            <>
                                                <div className='text-center mt-2 small text-danger' role="button" onClick={() => resetFilters()}>
                                                    {LanguageProvider.get('search.reset_filters')}
                                                </div>
                                                <InputGroup className="mt-5 mb-3" size={'sm'}>
                                                    <Form.Control placeholder="Etichetta gruppo filtri" value={filterGroupName} onChange={(e) => setFilterGroupName(e.target.value)} type="text" />
                                                    <Button variant="outline-secondary" onClick={() => saveFiltersGroup()}>
                                                        {LanguageProvider.get('search.save_filters')}
                                                    </Button>
                                                </InputGroup>
                                            </>
                                        ) : (
                                            <></>
                                        )}

                                        {entityUserFilters && entityUserFilters.length > 0 ? (
                                            <div className='mt-5'>
                                                {LanguageProvider.get('search.saved_filters')}<br />
                                                {entityUserFilters.map((item, index) => {
                                                    return (
                                                        <Badge key={index} onClick={() => applyFilters(item)} className="me-2 mb-2 mt-2 d-inline-flex align-items-center" role='button'>
                                                            {item.name} <FontAwesomeIcon icon="arrow-right" className="ms-1" />
                                                            <span className="ms-2 d-inline-flex align-items-center justify-content-center" style={{ backgroundColor: '#dc3545', color: '#fff', borderRadius: '50%', width: '16px', height: '16px', fontSize: '10px' }} onClick={(e) => askDeleteUserFilter(e, item)}><FontAwesomeIcon icon="xmark" /></span>
                                                        </Badge>
                                                    );
                                                })}
                                            </div>
                                        ) : (
                                            <></>
                                        )}

                                    </Col>
                                </Row>
                            </Dropdown.Header>
                        </Dropdown.Menu>
                    </Dropdown>
                    
                    {loading === true ? (
                        <Form.Control
                            disabled 
                            className='border-start-0 search-pro-input' 
                            value={queryString}
                            type="text" 
                            placeholder={LanguageProvider.get('defaults.search')}
                        />
                    ) : (
                        <>
                            {autoFocus === true && window.innerWidth > 900 ? (
                                <Form.Control
                                    autoFocus 
                                    className='border-start-0 search-pro-input' 
                                    value={queryString} 
                                    onChange={handleQueryStringChange}
                                    type="text" 
                                    placeholder={LanguageProvider.get('defaults.search')}
                                    onKeyDown={(e) => {
                                        if(e.key === 'Enter') {
                                            triggerSearch()
                                        }
                                    }}
                                />
                            ) : (
                                <Form.Control
                                    className='border-start-0 search-pro-input' 
                                    value={queryString} 
                                    onChange={handleQueryStringChange}
                                    type="text" 
                                    placeholder={LanguageProvider.get('defaults.search')}
                                    onKeyDown={(e) => {
                                        if(e.key === 'Enter') {
                                            triggerSearch()
                                        }
                                    }}
                                />
                            )}
                        </>
                    )}

                    {queryString && queryString.length > 0 ? (
                        <InputGroup.Text style={{ backgroundColor: 'white' }} role="button" onClick={() => resetSearch()}>
                            <FontAwesomeIcon icon="times" color="red" />
                        </InputGroup.Text>
                    ) : null}

                    <Button variant='success' onClick={() => triggerSearch()}>
                        {LanguageProvider.get('defaults.search')}
                    </Button>
                </InputGroup>

                {entityUserFilters && entityUserFilters.length > 0 ? (
                    <div>
                        {entityUserFilters.map((item, index) => {
                            return (
                                <Badge key={index} onClick={() => applyFilters(item)} className="me-2 mb-2 mt-2" role='button'>
                                    {item.name} <FontAwesomeIcon icon="arrow-right" className="ms-1" />
                                </Badge>
                            );
                        })}
                    </div>
                ) : (
                    <></>
                )}

            </Container>

            <Modal show={filterToDelete !== null} onHide={() => setFilterToDelete(null)} size="sm" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{LanguageProvider.get('defaults.delete_title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {LanguageProvider.get('defaults.delete_msg')} <strong>{filterToDelete?.name}</strong>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={() => setFilterToDelete(null)}>
                        {LanguageProvider.get('defaults.cancel')}
                    </Button>
                    <Button variant="danger" size="sm" onClick={confirmDeleteUserFilter}>
                        <FontAwesomeIcon icon="trash" className="me-1" /> {LanguageProvider.get('defaults.delete')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};